import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SliderProject } from './SliderProject';
import { findAndReplaceBreak } from '../../../shared/utils/findAndReplaceBreak';

import './Projects.scss';

interface IProps {
  id?: string;
  id_card: string;
  title: string;
  date: string;
  text: string;
  images: string | string[];
}

export const ProjectsItem = ({
  id,
  // id_card,
  title,
  date,
  text,
  images,
}: IProps): JSX.Element => {
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  return (
    <div className="container" id={id}>
      <div className="project-wrapper">
        {typeof images !== 'string' ? (
          <SliderProject images={images} />
        ) : (
          <img className="images-project" src={`image-project/${images}`} />
        )}

        <div className={show ? 'text-block active' : 'text-block'}>
          <p className="title-variant">
            <b>{title}</b>
          </p>
          <p>{date}</p>
          <p>{findAndReplaceBreak(text, true)}</p>
          <div
            className={show ? 'hidden' : 'shadows'}
            onClick={() => setShow(!show)}
          >
            {show
              ? t('ProjectButton.button.collapse')
              : t('ProjectButton.button.next')}
          </div>
        </div>
      </div>
      {/* {open && (
        <>
          <textarea
            rows={10}
            cols={74}
            defaultValue={text}
            onChange={changeHandler}
          />
          <button onClick={sendHandler}>send</button>
        </>
      )} */}
    </div>
  );
};
